import paper from 'paper';
import PathStyle from '@/services/PathStyle';

// eslint-disable-next-line no-unused-vars
export default class Shape {
    constructor(type, accept) {
        this.type = type;
        this.accept = accept;
        this.locked = false;
    }

    accepts(...operations) {
        if(this.locked){
            if(operations.includes('select') && operations.length == 1){
                return true;
            }
            else{
                return false;
            }
        }else{
            return this.accept.filter(a => operations.includes(a)).length > 0;
        }
    }

    item() {
        let item = paper.project.getItem({ id: this.pathId });
        if (item == null) {
            //console.error("Obsolete pathId for shape", this.pathId, this.id);
            this.updatePath();
            item = paper.project.getItem({ id: this.pathId });
        }
        return item;
    }

    linkTo(item) {
        this.removeItem();

        PathStyle.transparent(item);
        item.addTo(paper.project.layers.selectable);
        this.pathId = item.id;
    }

    removeItem() {
        if (this.pathId == null) return;
        let item = paper.project.getItem({ id: this.pathId });
        if (item && item.layer && item.layer.name !== 'blueprint') item.remove();
    }

    rotatedCorners() {
        let copy = this.item().clone();
        copy.rotation = -this.rotation;
        let topLeft = copy.bounds.topLeft.rotate(this.rotation, this.center),
            topRight = copy.bounds.topRight.rotate(this.rotation, this.center),
            bottomLeft = copy.bounds.bottomLeft.rotate(this.rotation, this.center),
            bottomRight = copy.bounds.bottomRight.rotate(this.rotation, this.center);

        copy.remove();

        return {topLeft, topRight, bottomLeft, bottomRight};
    }
}
